import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { TEMPLATES_DATA_INITIALIZE } from '@app/store/actionTypes';

interface TemplatesFiltersState {
  teamId: string | null;
}

const initialState: TemplatesFiltersState = {
  teamId: null,
};

const templatesFiltersSlice = createSlice({
  name: 'templates/templatesFilters',
  initialState,
  reducers: {
    changeTemplatesFilters(state, action: PayloadAction<{ teamId?: string | null }>) {
      const { teamId } = action.payload;

      if (teamId) {
        state.teamId = teamId;
      }
    },
  },
  extraReducers: (builder) => builder.addCase(TEMPLATES_DATA_INITIALIZE, () => initialState),
});

export default templatesFiltersSlice.reducer;

export const { changeTemplatesFilters } = templatesFiltersSlice.actions;
